import {dialog} from '@cypro/ui/components'
import {DialogBody, DialogFooter, DialogHeader} from '@cypro/ui/components'
import {Button, ButtonGroup, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

interface Props {
  id: string
  title: string
  description: string
}

export function DeleteResourceDialog({id, title, description}: Props) {
  const {t} = useTranslate('common')

  return (
    <>
      <DialogHeader>{title}</DialogHeader>

      <DialogBody minHeight="none">
        <Text>{description}</Text>
      </DialogBody>

      <DialogFooter>
        <ButtonGroup size="md" colorPalette="cyan" width="100%" justifyContent="flex-end">
          <Button variant="outline" colorPalette="gray" onClick={() => dialog.close(id, false)}>
            {t('cancel')}
          </Button>
          <Button colorPalette="red" onClick={() => dialog.close(id, true)}>
            {t('delete')}
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </>
  )
}
